import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import { DynamicComponent } from 'ui';
import { colorType } from 'utils/types';

import s from './Label.module.scss';

const cx = cn.bind(s);

const Label = ({
  children, color, as = 'div', className, ...attrs
}) => (
  <DynamicComponent tag={as} className={cx(className, 'label', color)} {...attrs}>
    { children }
  </DynamicComponent>
);

Label.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  color: colorType,
  as: PropTypes.string,
};

export default Label;
